import React, { ReactNode } from 'react';
import styles from './widgetLayout.module.scss';

export interface IWidgetLayoutProps {
  header?: ReactNode;
  searchBar?: ReactNode;
  body?: ReactNode;
}

export const WidgetLayout = ({ header, searchBar, body }: IWidgetLayoutProps) => {
  return (
    <div className={styles.widgetLayout} data-testid="widgetLayout">
      {header && <div className={styles.widgetLayout_header}>{header}</div>}
      {searchBar && <div className={styles.widgetLayout_searchBar}>{searchBar}</div>}
      {body && <div className={styles.widgetLayout_body}>{body}</div>}
    </div>
  );
};
